module.exports = __webpack_public_path__ + "img/ja_jp.811620b2.svg";